import { customerDetailQueryOptions } from '@/hooks/queries/credit/useCustomers'
import { queryClient } from '@/main'
import { createFileRoute } from '@tanstack/react-router'

// Layout route for one customer: carries the business-name crumb so children (the detail page,
// Prepare CLR) all sit under "Customers > <name>" in the breadcrumbs.
export const Route = createFileRoute('/_auth/_modules/credit/customers/$erp')({
  loader: async ({ params: { erp } }) => {
    const detail = await queryClient.ensureQueryData(customerDetailQueryOptions(erp))
    return { crumb: detail?.businessName ?? erp }
  },
})
